(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lx-rail')) {
    customElements.define('lx-rail', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-lx-toggle]');
        const extras = this.querySelectorAll('.product-item');
        const preview = Number(this.dataset.preview || 4);
        extras.forEach((item, index) => {
          if (index >= preview) item.classList.add('lx-more');
        });
        this.querySelectorAll('.lx-add').forEach((form) => {
          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            const button = form.querySelector('button');
            const id = new FormData(form).get('id');
            if (!id || button.disabled) return;
            button.disabled = true;
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, quantity: 1 })
              });
              if (!response.ok) throw new Error();
              const cart = await fetch('/cart.js').then((res) => res.json());
              document.querySelectorAll('.cart-count').forEach((el) => {
                el.textContent = el.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count;
              });
              button.textContent = 'Agregado';
            } catch (error) {
              button.textContent = 'No se pudo';
            }
            setTimeout(() => {
              button.textContent = 'Agregar';
              button.disabled = false;
            }, 1400);
          });
        });
        if (!button) return;
        button.addEventListener('click', () => {
          const open = this.classList.toggle('is-open');
          button.textContent = open ? 'Ver menos' : 'Ver todo';
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    });
  }
  const shop = document.querySelector('.lx-shop');
  if (shop && !shop.dataset.lxFilters) {
    shop.dataset.lxFilters = '1';
    const minEl = shop.querySelector('[data-lx-min]');
    const maxEl = shop.querySelector('[data-lx-max]');
    const baseMin = minEl.value;
    const baseMax = maxEl.value;
    let cat = '';
    const apply = () => {
      const stocks = [...shop.querySelectorAll('[data-lx-stock]:checked')].map((el) => el.value);
      const min = Number(minEl.value);
      const max = Number(maxEl.value);
      const sort = shop.querySelector('[data-lx-sort]').value;
      const priceOn = minEl.value !== baseMin || maxEl.value !== baseMax;
      const filtering = stocks.length < 2 || priceOn;
      shop.classList.toggle('is-filtering', filtering);
      shop.querySelectorAll('.lx-rail').forEach((rail) => {
        const wrongCat = cat && rail.dataset.cat !== cat;
        const grid = rail.querySelector('.lx-rail__grid');
        const cards = [...grid.querySelectorAll('.lx-card')];
        cards.sort((a, b) => {
          if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (sort === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          return Number(a.dataset.index) - Number(b.dataset.index);
        });
        cards.forEach((card) => grid.appendChild(card));
        let shown = 0;
        cards.forEach((card) => {
          const price = Number(card.dataset.price) / 100;
          const okStock = !stocks.length || stocks.includes(card.dataset.available);
          const okMin = !minEl.value || price >= min;
          const okMax = !maxEl.value || price <= max;
          const match = okStock && okMin && okMax;
          card.classList.toggle('is-match', match);
          if (match) shown += 1;
        });
        rail.classList.toggle('is-empty', wrongCat || shown === 0);
      });
    };
    shop.querySelector('.lx-filters').addEventListener('input', apply);
    shop.querySelector('[data-lx-sort]').addEventListener('change', apply);
    shop.querySelectorAll('.lx-cat').forEach((btn) => {
      btn.addEventListener('click', () => {
        shop.querySelectorAll('.lx-cat').forEach((el) => el.classList.remove('is-on'));
        btn.classList.add('is-on');
        cat = btn.dataset.lxCat || '';
        apply();
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
